import { RuleGroupType } from "react-querybuilder"

import {
  DEFAULT_DELAY_IN_DAYS,
  DEFAULT_DATE_FORMAT,
} from "@costory/shared/const"
import dayjs from "@costory/shared/dayjs"

export const generateCostCardFilters = (
  period: string,
  costColumn: string,
  previousDate: string,
  exclusionWhereClause: RuleGroupType,
) => {
  const periodDate = dayjs(period)
  const from = periodDate
    .subtract(DEFAULT_DELAY_IN_DAYS, "day")
    .subtract(1, "month")
    .startOf("month")
    .format(DEFAULT_DATE_FORMAT)
  const to = periodDate.endOf("month").format("YYYY-MM-DD")

  return {
    metricId: costColumn,
    currency: "USD" as const,
    limit: 10,
    aggBy: "Day" as const,
    groupBy: "cos_provider",
    from,
    to,
    datePreset: "LAST_3_MONTHS" as const,
    previousFrom: previousDate,
    previousTo: previousDate,
    whereClause: {
      ...exclusionWhereClause,
    },
  }
}
